module.exports = __webpack_public_path__ + "img/home_23_1.0c117177.png";